<template>
  <a-table
    :rowKey="record => record.id"
    :columns="topicColumns"
    :dataSource="topics"
    :loading="loading"
    :pagination="false"
    :expandedRowRender="renderSubTopics"
    size="small"
    :scroll="false"
    style="width: 100%"
  />
</template>

<script>
export default {
  name: 'LessonPlanTopics',
  props: {
    lessonPlanId: { type: Number, required: true },
  },
  data() {
    return {
      topics: [],
      loading: false,
      topicColumns: [
        { title: 'Unit Name', dataIndex: 'topic_name', key: 'topic_name' },
        { title: 'Total Period', dataIndex: 'total_periods', key: 'total_periods' },
        { title: 'Total Mark', dataIndex: 'marks', key: 'marks' },
        { title: 'Description', dataIndex: 'description', key: 'description' },
      ],
      subTopicColumns: [
        { title: 'Unit/chapter Name', dataIndex: 'sub_topic_name', key: 'sub_topic_name' },
        { title: 'Estimated Periods', dataIndex: 'estimated_periods', key: 'estimated_periods' },
      ],
    }
  },
  mounted() {
    this.fetchTopics()
    // NEW: Listen for the global refresh event
    this.$eventBus.$on('lessonPlanDataUpdated', this.fetchTopics)
  },
  beforeDestroy() {
  // IMPORTANT: Remove the listener to prevent memory leaks
    this.$eventBus.$off('lessonPlanDataUpdated', this.fetchTopics)
  },
  methods: {
    fetchTopics() {
      this.loading = true
      this.$http.get(`/api/lesson-plan/plans/${this.lessonPlanId}`)
        .then(({ data }) => {
          this.topics = data.data.topics || []
        })
        .catch(err => {
          this.$notification.error({ message: 'Failed to load topics' })
          console.error(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    renderSubTopics(topic) {
      return (
        <a-table
          rowKey="id"
          columns={this.subTopicColumns}
          dataSource={topic.sub_topics || []}
          pagination={false}
          size="small"
          scroll="false"
          style="width: 100%"
        />
      )
    },
  },
}
</script>
<style scoped>
.ant-table-expanded-row .ant-table-content {
  overflow-x: hidden !important;
}
</style>
